import { useState } from "react";
import "./ExportFilter.scss";
import { FormattedMessage } from "react-intl";
import OwDateInput from "../../../shared/OwDateInput/OwDateInput";
import OwButton from "../../../shared/OwButton/OwButton";
import * as _ from "lodash-es";
import { Moment } from "moment";

type Props = {
    searchFn: (queryString?: string) => void;
};

const ExportFilter = (props: Props) => {
    const [createdAtValue, setCreatedAtValue] = useState<Moment | null>(null);
    const [isActive, setIsActive] = useState(false);

    const handleDateChange = (date: any) => {
        setCreatedAtValue(date);
    };

    const performSearch = () => {
        const query: string[] = [];
        let queryString = "";

        if (!_.isNil(createdAtValue)) {
            query.push(`created_at=${createdAtValue.format("YYYY-MM-DD")}`);
        }

        if (query.length) {
            queryString = "?";

            queryString += query.join("&");
        }

        props.searchFn(queryString);
    };

    const resetSearch = () => {
        setCreatedAtValue(null);
        setIsActive(false);

        props.searchFn();
    };

    return (
        <div className="ExportFilter row mb-2">
            <div className="row mb-2">
                <div className="col-auto">
                    <label>
                        <FormattedMessage id="created_at" defaultMessage="_Created At_" description="Created At Title" />
                    </label>
                    <OwDateInput selectedDate={createdAtValue} fn={handleDateChange} />
                </div>

                <div className={"col d-flex align-items-end"} style={{ marginBottom: "8px" }}>
                    <div>
                        <label />
                    </div>
                    <div>
                        <OwButton
                            disableOnActive={true}
                            active={isActive}
                            leftIconClass=""
                            className="btn-primary"
                            title="search"
                            fn={performSearch}
                        />

                        <button className="btn btn-danger btn-sm ms-2" onClick={resetSearch}>
                            <FormattedMessage id="reset" defaultMessage="_Reset_" description="Reset Title" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExportFilter;
